import { useEffect, useState } from "react";
import useDataBean from "../../../core/services/dataBean/useDataBean";
import { Singleton } from "../../../core/services/Singleton";
import { toast } from "react-toastify";
import { ListMenu } from "../../theme/Component/ListMenu";
import { BasicPage } from "../../theme/Component/BasicPage";
import { BasicTable } from "../../theme/Component/BasicTable";
import { Modal } from "../../theme/Component/Modal";
import { Submacroprocces } from "../ParametrosTalentoHumano/MacroProcess/Submacroprocces";
import { ModalConfirm } from "../../theme/Component/ModalConfirm";
import { AdminService } from "../../../core/services/AdminService";
import { BsSend } from "react-icons/bs";
import { FileInput } from "../../theme/Component/FileInput";
import { _EmployeeContract } from "../../../core/services/dataBean/EntityCatalog";
import { BasicButton } from "../../theme/Component/BasicButton";
import { PrintJson } from "../../theme/Component/PrintJson";




export const Contratoslaborales = () => {
    const { instance, bean, setBean, lista, setLista } = useDataBean(_EmployeeContract);

    const [fileI, setFileI] = useState<any>({});

    useEffect(() => {
        getLista()
    }, [])



    const getLista = () => {
        instance.exportEmployeeContractsTemplateXlsxFile(null).then(
            (res) => {
                setLista(res)
            }
        ).catch(
            err => {
                toast.error("no se pudo generar el archivo")
                console.log(err)
            }
        )
    }

    const importar = () => {
        instance.importEmployeeContracts(fileI.Media, fileI.MediaContext, null).then(
            (resp: any) => {
                //console.log(resp)
                toast.success("Información Enviada")
            }
        ).catch(
            err => {
                toast.error("error al importar")
                console.log(err)
            }
        )
    }


    return (
        <BasicPage titulo="Importar Contratos Laborales ">

            <div className="row">
                <div className="col-md-4">
                    <label >Descargar formato de importación de contratos laborales</label>

                    <div className="list-group mt-2" style={{ maxHeight: "52vh", overflow: "auto" }}>
                        {Array.isArray(lista) && lista.length > 0 &&
                            lista.map((item: any, index: number) => {
                                const DataItem = item.DataBeanProperties;
                                return (
                                    <div
                                        key={index}
                                        className="list-group-item d-flex justify-content-between align-items-center pointer"
                                        onClick={() => {
                                            window.open(DataItem.URLLink, "_blank");
                                        }}
                                    >
                                        <span className="d-flex gap-1" style={{
                                            wordBreak: "break-word",
                                            whiteSpace: "normal"
                                        }}>
                                            <div className="icon-wrapper">
                                                <i className="ri-file-download-line fs-3"></i>
                                            </div>

                                            <div className="flex-grow-1">
                                                {DataItem.Filename}
                                            </div>
                                        </span>
                                    </div>
                                );
                            })
                        }

                    </div>
                </div>
                <div className="col-md-8">
                    <FileInput directory="contrato-laboral" label="Importar Contratos Laborales" onCreate={(e: any) => {
                        setFileI(e);
                    }} />
                    
                    <BasicButton useMargin disable={!fileI.Media} icon="ri-folder-upload-line" eventClick={importar}>Importar</BasicButton>
                </div>
            </div>
        </BasicPage>
    )
}